<script>
import headNav from "../components/headNav.vue";
import router from "../router";
export default {
  name: "boxMain",
  components:{
    headNav
  },
  data(){
    return{

    }
  },
  methods:{
    go(name){
      router.push(
        {
          name
        }
      )
    },
	gos(name, item) {
		router.push({
			name,
			query: {
				id: item
			}
		})
	},
  }



}
</script>

<template>
  <div>
    <head-nav></head-nav>
	<router-view id="views" style="padding-top: 60px"> </router-view>
   <!-- <keep-alive>
		
	</keep-alive> -->
    <footer class="section-sm bg-tertiary" style="color: #000;background-color: #dedede !important;margin-top: 100px; position: relative;">
      <div class="container" >
        <div class="row justify-content-between">
          <div class="col-lg-2 col-md-4 col-6 mb-4">
            <div class="footer-widget">
              <h5 style="color: #000 !important;" class="mb-4 text-primary font-secondary">服务与支持</h5>
              <ul class="list-unstyled">
                <li class="mb-2 colorss"><a @click="gos('message',7)">同步拍卖指南</a>
                </li>
                <li class="mb-2 colorss"><a @click="gos('message',13)">即刻拍使用指南</a>
                </li>
				<li class="mb-2 colorss"><a @click="gos('message',11)">网络拍卖指南</a>
                </li>
              </ul>
            </div>
          </div>
<!--          <div class="col-lg-2 col-md-4 col-6 mb-4">-->
<!--            <div class="footer-widget">-->
<!--              <h5 class="mb-4 text-primary font-secondary">About</h5>-->
<!--              <ul class="list-unstyled">-->
<!--                <li class="mb-2"><a href="#!">Benefits</a>-->
<!--                </li>-->
<!--                <li class="mb-2"><a href="#!">Careers</a>-->
<!--                </li>-->
<!--                <li class="mb-2"><a href="#!">Our Story</a>-->
<!--                </li>-->
<!--                <li class="mb-2"><a href="#!">Team</a>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
          <div class="col-lg-2 col-md-4 col-6 mb-4">
            <div class="footer-widget">
              <h5 style="color: #000 !important;" class="mb-4 text-primary font-secondary">关于我们</h5>
              <ul class="list-unstyled">
                <li class="mb-2 colorss"><a  @click="go('about')">公司介绍</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-2 col-md-4 col-6 mb-4">
            <div class="footer-widget">
              <h5 style="color: #000 !important;" class="mb-4 text-primary font-secondary">发现</h5>
              <ul class="list-unstyled">
                <li class="mb-2 colorss"><a  @click="go('faxian')">资讯</a>
                </li>
              </ul>
            </div>
          </div>
		  <div class="bei">
			  鲁ICP备203045979-2<img src="../view/images/c6b88c9132dc7f6cb337345f862b746.jpg" style="width: 22px; height: 22px;" alt="" /><a href="https://beian.mps.gov.cn/#/query/webSearch" rel="noreferrer" target="_blank" style="color: #000;">鲁公网安备37149202001181</a>
		  </div>
          <!-- <div class="col-lg-4 col-md-12 newsletter-form">
            <div style=" padding: 35px;">
              <h5 style="color: #000 !important;" class="mb-4 text-primary font-secondary">Introduce</h5>

              <p class="mb-0">Website Introduction</p>
              <div class="mb-0" style="margin-top: 20px">
                <ul class="list-unstyled list-inline mb-0 social-icons" style="display: flex;">
                  <li class="list-inline-item me-3"><div ><i class="fab fa-facebook-f"></i></div>
                  </li>
                  <li class="list-inline-item me-3"><div ><i class="fab fa-twitter"></i></div>
                  </li>
                  <li class="list-inline-item me-3"><div ><i class="fab fa-instagram"></i></div>
                  </li>
                </ul>
              </div>
            </div>
          </div> -->
        </div>

      </div>
    </footer>
  </div>
</template>

<style scoped>
@import "../../css/style.css";
@import "../../plugins/slick/slick.css";
@import "../../plugins/font-awesome/fontawesome.min.css";
@import "../../plugins/font-awesome/brands.css";
@import "../../plugins/font-awesome/solid.css";

.colorss{
	color: #5b5959;
}
.bei{
	font-size: 18px;
	position: absolute; 
	bottom: 0;
	left: 40%;
	
}
</style>




// WEBPACK FOOTER //
// src/view/boxMain.vue